import React from "react"

import { AppDataTable } from "@components"
import { categoryColumn, dateColumn } from "./columns"
import BITableActions from "./Actions"


export default function BITable({ dataTable, columnValues, filters, ...props }) {
	return <AppDataTable
		title="Price Comparison"
		toolbarProps={{ filters: filters }}
		data={dataTable}
		columns={[
			...categoryColumn(filters?.reportType),
			...columnValues?.length ? columnValues?.map((date, idx) => dateColumn(date, idx)) : []
		]}
		options={{
			tableBodyHeight: "1000",
			viewColumns: true,
			search: true,
			customToolbar: () => <BITableActions/>,
		}}
		{...props}
	/>
}